import { Link } from "react-router-dom";
import { CalendarDays, Phone } from "lucide-react";
import { LOCATIONS } from "../lib/content";

const WB = LOCATIONS["west-branch"];

/** Mobile-only persistent CTA — these customers book from a parking lot. */
export const StickyBookBar = () => (
  <div
    data-testid="sticky-book-bar"
    className="sm:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 bg-navy/95 backdrop-blur-md px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
  >
    <div className="flex items-center gap-3">
      <a
        href={WB.phoneHref}
        data-testid="sticky-call-button"
        aria-label={`Call West Branch Marina at ${WB.phone}`}
        className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/25 text-white"
      >
        <Phone className="h-5 w-5" aria-hidden="true" />
      </a>
      <Link
        to="/boat-rentals/west-branch"
        data-testid="sticky-book-now-button"
        className="flex h-12 flex-1 items-center justify-center gap-2 rounded-full bg-ember font-bold text-white active:scale-[0.98] transition-transform"
      >
        <CalendarDays className="h-5 w-5" aria-hidden="true" />
        Book Now
      </Link>
    </div>
  </div>
);

export default StickyBookBar;
